import { useIntervalFn } from '@vueuse/core';

const FIVE_MINUTES = 300_000;

export default defineNuxtPlugin(async() => {
    const { jwtTokenCookie } = useJwtCookies();

    const userStore = useUserStore();

    const { jwtToken } = storeToRefs(userStore);

    jwtToken.value = jwtTokenCookie.value;

    if (jwtToken.value) {
        await useUserStore().fetchToken();

        if (jwtToken.value) {
            await userStore.fetchUserRelations();
        }
    }

    useIntervalFn(async() => {
        if (jwtToken.value) {
            await refreshNuxtData(USER_STORE_DATA_KEY_TOKEN);
        }
    }, FIVE_MINUTES);
});
